import React, { useEffect } from 'react';
import moment from 'moment';

import { withTranslation } from 'react-i18next';
import Linkify from 'linkifyjs/react';
import Avatar from '../../components/avatar/avatar';

// stateless component
export const Message = ({
  currentUserId, text, createdAt, user, isCurrentUser, seenBy, onSeen
}) => {
  useEffect(() => {
    if (!seenBy || seenBy.filter(log => (log.user && log.user._id) === currentUserId).length === 0) {
      // the current user has not yet seen this message.
      // mark it as seen.
      onSeen();
    }
  }, []);

  // `userId` is what makes the avatar / name open the public profile modal.
  const avatar = <Avatar name={user.name} userId={user.id} diameter={28} />;

  return (
    <div className={`chat-message${isCurrentUser ? ' chat-message-isCurrentUser' : ''}`}>
      {!isCurrentUser && avatar}
      <div className='chat-message-body'>
        {!isCurrentUser && user.name && (
          <span className='chat-message-sender'>
            <Avatar nameOnly name={user.name} userId={user.id} />
          </span>
        )}
        <div className={isCurrentUser ? 'chat-message-content-isCurrentUser' : 'chat-message-content'}>
          <span className={isCurrentUser ? 'chat-message-content-text-isCurrentUser' : 'chat-message-content-text'}><Linkify>{text}</Linkify></span>
          <span className={isCurrentUser ? 'chat-message-content-text-date-isCurrentUser' : 'chat-message-content-text-date'}>{moment(new Date(createdAt)).format('h:mm a')}</span>
        </div>
      </div>
      {isCurrentUser && avatar}
    </div>
  );
};

export default withTranslation()(Message);
